<template>
    <div class="d-flex flex-column justify-center ">
        <v-card-text v-for="(value, key) in filtrarTurnos" :key="key"
            class="d-flex flex-row justify-start align-start pa-2 ">
            <v-icon color="primary" class="mr-2">{{ icon[key] }}</v-icon>
            <div class="d-flex flex-column font-weight-bold black--text">
                {{ key.toUpperCase() }}:
            </div>
            <div class="d-flex flex-column black--text ml-2">
                {{ value }}
            </div>
        </v-card-text>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


export default {
    name: "TurnoCard",
    data() {
        return {
            icon: {
                fecha: 'mdi-calendar-outline',
                hora: 'mdi-clock-outline',
                direccion: 'mdi-map-marker-outline',
                sede: 'mdi-home-city-outline',
            },
        }
    },
    computed: {
        ...mapGetters('auth', ['nroafi', 'loadSkeleton', 'user']),
        ...mapGetters('turnos', ['tmpTurno', 'nuevoTurno', 'turnosActivos']),
        filtrarTurnos() {
            const { idDistrito, nroafi, ...turnoFiltrado } = this.tmpTurno
            return {
                fecha: this.formatDate(turnoFiltrado.fecha),
                hora: turnoFiltrado.hora,
                direccion: turnoFiltrado.direccion,
                sede: `${turnoFiltrado.distrito}`,
            }
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        isObject(value) {
            return (
                typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value)
            )
        },

    },
    props: ['title', 'items']
}
</script>

<style>
.rounded-card {
    /* You can adjust the value to control the roundness of the corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Optional: Add shadow for a more prominent card effect */
}
</style>